var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-card"},[_c('section',{staticClass:"modal-card-body"},[_c('SearchOPDForGeneral',{on:{"HNSelected":_vm.HNSelected}})],1),_c('footer',{staticClass:"modal-card-foot"},[_c('b-button',{attrs:{"type":"is-danger"},on:{"click":_vm.close}},[_vm._v("Close")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }